import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import { FC } from 'react';
import { MdLocationOn, MdPerson } from 'react-icons/md';

const fakeChipWidths = [48, 60, 40];

export const ProDirectoryPreviewCardPlaceholder: FC = () => {
  return (
    <Box
      sx={{
        width: 285,
        height: 255,
        borderRadius: 3,
        bgcolor: 'background.paper',
        boxShadow: '0 1px 8px rgba(0,0,0,0.10)',
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        opacity: 0.45,
        filter: 'grayscale(1)',
        pointerEvents: 'none',
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ px: 2, pt: 2, pb: 1.5 }}>
        <Avatar
          sx={{ width: 52, height: 52, flexShrink: 0, bgcolor: theme => alpha(theme.palette.text.secondary, 0.2) }}
        >
          <MdPerson />
        </Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              width: '70%',
              height: 12,
              borderRadius: 1,
              bgcolor: 'action.disabledBackground',
              mb: 0.75,
            }}
          />
          <Box
            sx={{
              width: '45%',
              height: 10,
              borderRadius: 1,
              bgcolor: 'action.disabledBackground',
            }}
          />
        </Box>
      </Stack>

      <Box sx={{ px: 2, pb: 2, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <MdLocationOn size={14} color="inherit" style={{ flexShrink: 0, opacity: 0.5 }} />
          <Box sx={{ width: '55%', height: 10, borderRadius: 1, bgcolor: 'action.disabledBackground' }} />
        </Stack>

        <Box sx={{ width: '65%', height: 10, borderRadius: 1, bgcolor: 'action.disabledBackground', mt: 0.25 }} />

        <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.25 }}>
          {fakeChipWidths.map(width => (
            <Chip key={width} label="" size="small" variant="outlined" sx={{ width, '& .MuiChip-label': { px: 0 } }} />
          ))}
        </Stack>
      </Box>

      <Box flex={1} />

      <Box sx={{ px: 2, pb: 2 }}>
        <Box sx={{ width: '100%', height: 36, borderRadius: 1, bgcolor: 'action.disabledBackground' }} />
      </Box>
    </Box>
  );
};
